import { createI18n } from "vue-i18n";
import { locales } from "@/locales";

export const i18n = createI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: "en",
  messages: locales,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});
